import { useState } from "react"
import axios from "axios"
import api from "../config/backend"
import "./css/AddNewExpense.css"
import { toast } from "react-toastify"

const AddNewExpense = ({ setOpen, setExpensesUpdatedRefresh }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [selectedAccountType, setSelectedAccountType] = useState("Fixed Asset")
    const [accountName, setAccountName] = useState("")
    const [accountCode, setAccountCode] = useState("")
    const [description, setDescription] = useState("")

    const token = localStorage.getItem("_crm__token")

    const categories = ["Cost Of Goods Sold", "Expense", "Long Term Liability", "Other Current Liability", "Fixed Asset", "Other Current Asset"]

    const createExpenseAccount = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/create-expac`, {
            token,
            title: accountName,
            category: selectedAccountType,
            description
        })

        if (data.success) {
            setOpen(false)
            setExpensesUpdatedRefresh(prev => prev + 1)
            toast.success(data.message)
        } else {
            toast.error(data.message)
        }
    }
    
    return (
        <div className="_3kns" onClick={() => setOpen(false)}>
            <div className="chews-irks" onClick={e => e.stopPropagation()}>
                <h3>Create Expense Account</h3>
                <div className="livider-vise">
                    <div className="bromisms-ars">
                        Account Type*
                    </div>
                    <div className="whingy-peep">
                        <div className="poortith-loch">
                            <div onClick={e => {
                                e.stopPropagation()
                                setDropdownOpen(prev => !prev)
                            }} className="salients-rap">
                                {selectedAccountType ? selectedAccountType : "Select an account"}
                            </div>
                            {dropdownOpen ? <div onClick={e => e.stopPropagation()} className="cirrus-tee">
                                <div className="pullmans-tom">
                                    {categories.map((expenseAccount, expenseAccountIndex) => {
                                        return (
                                            <div key={expenseAccountIndex} className="poetise-row" onClick={() => {
                                                setSelectedAccountType(expenseAccount)
                                                setDropdownOpen(false)
                                            }}>
                                                <div className="winked-flit">
                                                    {expenseAccount}
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div> : undefined}
                        </div>
                    </div>
                </div>
                <div className="livider-vise">
                    <div className="bromisms-ars">
                        Account Name*
                    </div>
                    <div className="whingy-peep">
                        <input
                            className="bulliest-item"
                            value={accountName}
                            onChange={e => setAccountName(e.target.value)}
                        />
                    </div>
                </div>
                <div className="livider-vise">
                    <div className="bromisms-ars">
                        Account Code
                    </div>
                    <div className="whingy-peep">
                        <input
                            className="bulliest-item"
                            value={accountCode}
                            onChange={e => setAccountCode(e.target.value)}
                        />
                    </div>
                </div>
                <div className="livider-vise">
                    <div className="bromisms-ars">
                        Description
                    </div>
                    <div className="whingy-peep">
                        <textarea
                            value={description}
                            onChange={e => setDescription(e.target.value)}
                        />
                    </div>
                </div>
                <div className="wicks-nub">
                    <button onClick={() => createExpenseAccount()}>Save account</button>
                </div>
            </div>
        </div>
    )
}

export default AddNewExpense
